
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Note } from '@/store/types';
import { namespace } from 'vuex-class';

const globalModule = namespace('global');

@Component
export default class NoteItem extends Vue {
  @Prop({ type: Object as () => Note, required: true })
  note!: Note;

  showEditIcon = false;

  toggleEditIcon() {
    this.showEditIcon = !this.showEditIcon;
  }

  viewNote() {
    this.setSelectedNote(this.note);
    this.setShowNoteDialog(true);
  }

  @globalModule.Mutation
  setSelectedNote!: (note: Note) => void;

  @globalModule.Mutation
  setShowNoteDialog!: (payload: boolean) => void;
}
